var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paragraph !== null && !_vm.isMobileOnly)?_c('article',{staticClass:"kiswe-notification"},[_c('span',[_c('icon',{attrs:{"name":"exclamation-triangle"}})],1),_c('section',[_c('p',[_vm._v(_vm._s(_vm.paragraph))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }